import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivationEnd } from '@angular/router';
import { Constants } from 'src/app/_helpers';
import { filter } from 'rxjs/operators';
import { DrawService, CommonService } from 'src/app/_services';

@Component({
  selector: '.lastResultWrap',
  templateUrl: './result-panel.component.html'
})
export class ResultPanelComponent implements OnInit, OnDestroy {

  gameCode;
  gameData: any;
  gameDataSubscription: any;
  routeSubscription: any;
  lastDrawResult = [];
  lastDrawResultName = [];
  eveningStartHours = Constants.EVENING_START_HOURS;

  constructor(
    private drawService: DrawService,
    private router: Router,
    private commonService: CommonService
  ) {
    this.routeSubscription = router.events.pipe(
      filter(e => e instanceof ActivationEnd && typeof e.snapshot.data.gameCode != 'undefined'),
    ).subscribe(val => {
      this.gameCode = (<any>val).snapshot.data.gameCode;
      this.commonService.iframe_resize();
    });
  }

  ngOnInit() {
    this.gameDataSubscription = this.drawService.subscribeGameData().pipe(
      filter(response => response != null && typeof response.data.responseData.gameRespVOs[0].numberConfig != 'undefined')).subscribe((response: any) => {
        response.data.responseData.gameRespVOs.forEach(element => {
          if (element.gameCode == this.gameCode) {
            this.lastDrawResult = [];
            this.gameData = element;                          
            if (this.gameData.lastDrawWinningResultVOs.length == 0 && typeof Constants.CLIENT_RESULTS_HARDCODE[Constants.CLIENT_CODE][Constants.DRAW_ENGINE][this.gameCode] != 'undefined') {
              this.gameData.lastDrawWinningResultVOs = Constants.CLIENT_RESULTS_HARDCODE[Constants.CLIENT_CODE][Constants.DRAW_ENGINE][this.gameCode];
            }
            this.gameData.lastDrawWinningResultVOs.forEach(element => {
              element.lastDrawDateTime = this.drawService.changeDateFormat(element.lastDrawDateTime);
            });
            if (element.gameCode == Constants.THAI_LOTTERY || element.gameCode == Constants.LOTTERY_DIAMOND) {
              let temp = this.gameData.lastDrawWinningResultVOs[0].winningNumber.split(',');
              this.lastDrawResult = [
                temp[0].split('#').join(''),
                temp[1].split('#').join(''),
                temp[2].split('#').join(''),
                temp[3].split('#').join(''),
                temp[4].split('#').join(''),
                temp[5].split('#').join(''),
                temp[6].split('#').filter(function (el) {
                  return el != -1;
                }).join(''),
              ];
            }
            if (element.gameCode == Constants.BichoRapido) {
              let temp = this.gameData.lastDrawWinningResultVOs[0].winningNumber.split(',');
              this.lastDrawResult = [
                temp[0].split('#').join(''),
                temp[1].split('#').join(''),
                temp[2].split('#').join(''),
                temp[3].split('#').join(''),
                temp[4].split('#').join(''),
              ];
              for(let lDR of this.lastDrawResult) {
                for(let nc=0;  nc<this.gameData.numberConfig.range[2].ball.length; nc++) {
                  // if(nc == (lDR.substr(2)-1)) {
                  if(this.gameData.numberConfig.range[2].ball[nc].number == lDR.substr(2)) {
                    let labelName = this.gameData.numberConfig.range[2].ball[nc].label.split(',');
                    this.lastDrawResultName.push(labelName[1] + ' - ' + labelName[0]);
                    break;
                  }
                }
              }
            }
            if (element.gameCode == Constants.MYANMAR_2D) {
              let tempDrawResult = {};
              this.gameData.lastDrawWinningResultVOs.forEach(element => {
                let date = element.lastDrawDateTime.split(" ");
                if (!tempDrawResult[date[0]]) {
                  tempDrawResult[date[0]] = { am: [], pm: [], date: date[0] }
                }
                // let ampm = parseInt(date[1].split(":")[0]) >= 12 ? 'pm' : 'am';
                let ampm = parseInt(date[1].split(":")[0]) >= this.eveningStartHours ? 'pm' : 'am';
                tempDrawResult[date[0]][ampm].push(
                  element.winningNumber.split(',')[0].split('#').filter(function (el) {
                    return el != -1;
                  }).join(''),
                );
              });
              this.lastDrawResult = Object.values(tempDrawResult);
            }
            if(element.gameCode == Constants.MINI_ROULETTE) {
              let filteredElement = this.gameData.numberConfig.range[0].ball.filter(element => element.number == this.gameData.lastDrawWinningResultVOs[0].winningNumber);
              this.gameData['matchedWinningColor'] = filteredElement[0].color[0].toUpperCase() + filteredElement[0].color.slice(1).toLowerCase();  

            }
          }
        });
      });
  }

  ngOnDestroy(): void {
    if (typeof this.routeSubscription != 'undefined') {
      this.routeSubscription.unsubscribe();
    }
    if (typeof this.gameDataSubscription != 'undefined') {
      this.gameDataSubscription.unsubscribe();
    }
  }

  getLastDrawResult(i) {
    if (typeof this.lastDrawResult != 'undefined') {
      return this.lastDrawResult[i];
    } else {
      return '';
    }
  }

}                  


       